import LogRocket from 'logrocket';
import packageJson from '../../package.json';

const SENSITIVE_HEADERS = ['authorization', 'cookie', 'set-cookie'];
const SENSITIVE_PARAMS = ['password', 'senha', 'username', 'token', 'access_token', 'refresh_token'];
const SENSITIVE_PARAM_PATTERN = new RegExp(`([?&](?:${SENSITIVE_PARAMS.join('|')})=)[^&#]*`, 'gi');

export const sanitizeUrl = url => (url ? url.replace(SENSITIVE_PARAM_PATTERN, '$1[removido]') : url);

export const sanitizeHeaders = headers => Object.fromEntries(Object.entries(headers || {}).filter(([name]) => !SENSITIVE_HEADERS.includes(name.toLowerCase())));

export const sanitizeRequest = request => ({
  ...request,
  url: sanitizeUrl(request.url),
  referrer: sanitizeUrl(request.referrer),
  headers: sanitizeHeaders(request.headers),
  body: undefined,
});

export const sanitizeResponse = response => ({
  ...response,
  headers: sanitizeHeaders(response.headers),
  body: undefined,
});

export const startLogRocket = () => {
  const isProduction = window.location.origin === 'https://app.infoprice.co';
  const isInfoPricer = JSON.parse(localStorage.getItem('usuario'))?.email?.includes('infoprice');

  if (isProduction && !isInfoPricer) {
    LogRocket.init('yrcc0j/portal-cliente-infoprice', {
      release: `${packageJson.version}`,
      network: {
        requestSanitizer: sanitizeRequest,
        responseSanitizer: sanitizeResponse,
      },
      browser: {
        urlSanitizer: sanitizeUrl,
      },
    });
    LogRocket.identify(JSON.parse(localStorage.getItem('usuario'))?.email, {
      email: JSON.parse(localStorage.getItem('usuario'))?.email,
    });

    if (window?.heap) {
      LogRocket.getSessionURL(sessionURL => {
        window.heap.track('LogRocket', { sessionURL });
      });
    }
  }
};
